import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  siteOptions: [],
  filteredInsights: [],
  selectedBusinessInsight: null,
  selectedCategory: null,
  selectedSubCategory: null,
  selectedStatus: null,
  selectedStatusActionDate: null,
  selectedDueDate: null,
  selectedAssignee: null,
  createdOnDate: null,
  page: 0,
  rowsPerPage: 10,
  selectedRows: [],
  singleRowData: [],
  sort: {
    keytoSort: 'modified_at',
    direction: 'desc',
  },
  businessInsightsList: [],
  singleBusinessInsightDetails: [],
  openModalType: null,
  selectedSite: [],
  selectedDimension: [],
  selectedSharedUid: null,
  taskDetails: [],
  keywordPerformance: [],
  newSearchTerms: [],
  impressionShare1: [],
  impressionShare2: [],
  dailyAverage: [],
}

const businessInsightsSlice = createSlice({
  name: 'businessInsights',
  initialState,
  reducers: {
    setBusinessInsightsList: (state, action) => {
      state.businessInsightsList = action.payload
    },
    setSelectedBusinessInsight: (state, action) => {
      state.selectedBusinessInsight = action.payload
    },
    setFilteredInsights: (state, action) => {
      state.filteredInsights = action.payload
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload
    },
    setSelectedSubCategory: (state, action) => {
      state.selectedSubCategory = action.payload
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload
    },
    setSelectedStatusActionDate: (state, action) => {
      state.selectedStatusActionDate = action.payload
    },
    setSelectedDueDate: (state, action) => {
      state.selectedDueDate = action.payload
    },
    setSelectedAssignee: (state, action) => {
      state.selectedAssignee = action.payload
    },
    setCreatedOnDate: (state, action) => {
      state.createdOnDate = action.payload
    },
    setPage: (state, action) => {
      state.page = action.payload
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload
    },
    setSingleRowData: (state, action) => {
      state.singleRowData = action.payload
    },
    setSort: (state, action) => {
      state.sort = action.payload
    },
    setSingleBusinessInsightDetails: (state, action) => {
      state.singleBusinessInsightDetails = action.payload
    },
    setOpenModalType: (state, action) => {
      state.openModalType = action.payload
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload
    },
    setSelectedDimension: (state, action) => {
      state.selectedDimension = action.payload
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload
    },
    setTaskDetails: (state, action) => {
      state.taskDetails = action.payload
    },
    setKeywordPerformance: (state, action) => {
      state.keywordPerformance = action.payload
    },
    setNewSearchTerms: (state, action) => {
      state.newSearchTerms = action.payload
    },
    setImpressionShare1: (state, action) => {
      state.impressionShare1 = action.payload
    },
    setImpressionShare2: (state, action) => {
      state.impressionShare2 = action.payload
    },
    setDailyAverage: (state, action) => {
      state.dailyAverage = action.payload
    },
  },
})

export const {
  setSiteOptions,
  setBusinessInsightsList,
  setSelectedBusinessInsight,
  setFilteredInsights,
  setSelectedCategory,
  setSelectedSubCategory,
  setSelectedStatus,
  setSelectedStatusActionDate,
  setSelectedDueDate,
  setSelectedAssignee,
  setCreatedOnDate,
  setPage,
  setRowsPerPage,
  setSelectedRows,
  setSingleRowData,
  setSort,
  setSingleBusinessInsightDetails,
  setOpenModalType,
  setSelectedSite,
  setSelectedSharedUid,
  setSelectedDimension,
  setTaskDetails,
  setKeywordPerformance,
  setNewSearchTerms,
  setImpressionShare1,
  setImpressionShare2,
  setDailyAverage,
} = businessInsightsSlice.actions;

export default businessInsightsSlice.reducer
